import styled from 'styled-components'

import breakpoints from '../../../theme/breakpoints'
import FormikForm from '../../form/FormikForm'
import FormText from '../../form/FormText'
import FormCheckbox from '../../form/FormCheckbox'
import FormSubmitButton from '../../form/FormSubmitButton'
import FormPhone from '../../form/FormPhone'
import FormErrors from '../../form/FormErrors'
import ActionButton from '../../ActionButton'

export const Form = styled(FormikForm)``

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const FormFieldsAttendant = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const AttendantHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const RemoveButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.pureBlack};

  svg {
    width: 18px;
  }
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.WebTitleH3};
  color: ${({ theme }) => theme.colors.pureBlack};
`

export const Button = styled(ActionButton)`
  width: fit-content;
  color: ${({ theme }) => theme.colors.pureBlack};
  margin: 0 auto;

  svg {
    width: 11px;
  }
`

export const FormFieldsName = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const FieldFormText = styled(FormText)`
  width: 100%;
`

export const FieldFormPhone = styled(FormPhone)`
  width: 100%;
`

export const FieldFormCheckbox = styled(FormCheckbox)``

export const Errors = styled(FormErrors)`
  margin-top: 36px;
  text-align: center;
`

export const SubmitButton = styled(FormSubmitButton)`
  display: block;
  margin: 36px auto auto auto;
`
